import CoreButton from 'client/components/core/BlueButton'
import { createCarouselItem } from 'client/components/entities/Carousel'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { CarouselInterface } from 'src/shared/entities/carousel/carousel.schema'
import React from 'react'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import EntityInnerItems from '../../components/EntityInnerItems'
import { useUpdateProp } from '../../hooks/useUpdateProps'
import HtmlAttrId from '../../options/HtmlAttrId'
import VerticalAlign from '../../styles/VerticalAlign'
import DeviceAppearanceNew from '../../options/DeviceAppearance/DeviceAppearanceNew'

type CarouselSettingsProps = {
  entity: CarouselInterface
  defaultEntity?: CarouselInterface
}

function CarouselSettings({ entity, defaultEntity }: CarouselSettingsProps) {
  const updateProp = useUpdateProp(entity)
  const { isMobile } = useDeviceModeContext()
  const { t } = useTypedTranslation()

  return (
    <>
      <EntityInnerItems
        entity={entity}
        createEntityInnerItem={createCarouselItem}
        addItemButtonText="entity_settings.carousel.item.add"
        removeWarningText="entity_settings.carousel.remove_item_warning"
        renderInnerItem={(innerItem, switchToItem, isActive) => (
          <CoreButton
            onClick={switchToItem}
            // @ts-ignore
            styles={{
              marginRight: 'auto',
              ...(!isActive ? { background: '#bcbcbc' } : {}),
            }}
          >
            {t('entity_settings.carousel.item_number_icu', {
              itemNumber: innerItem.creationItemNumber,
            })}
          </CoreButton>
        )}
      />
      <VerticalAlign
        label={'entity_settings.carousel.item_vertical_align.title'}
        align={
          isMobile ? entity.mobileVerticalAlignment : entity.verticalAlignment
        }
        update={updateProp(
          isMobile ? 'mobileVerticalAlignment' : 'verticalAlignment',
        )}
      />
      {/*@ts-ignore*/}
      <CheckboxControl
        label="entity_settings.carousel.show_arrows.label"
        update={updateProp('showArrows')}
        mobileUpdate={updateProp('mobileShowArrows')}
        value={entity.showArrows}
        mobileValue={entity.mobileShowArrows}
      />
      <ColorPickerControl
        update={updateProp('controlsColor')}
        color={entity.controlsColor}
        label="entity_settings.carousel.controls_color.label"
        singleColorMode
      />
      <ColorPickerControl
        update={updateProp('arrowsColor')}
        color={entity.arrowsColor}
        label="entity_settings.carousel.arrows_color.label"
        singleColorMode
      />
      <SizeAndPositionGroup
        padding={isMobile ? entity?.mobilePadding : entity.padding}
        defaultPadding={
          isMobile ? defaultEntity?.mobilePadding : defaultEntity?.padding
        }
        updatePadding={updateProp(isMobile ? 'mobilePadding' : 'padding')}
        margin={isMobile ? entity.mobileMargin : entity.margin}
        defaultMargin={
          isMobile ? defaultEntity?.mobileMargin : defaultEntity?.margin
        }
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearanceNew
        entity={entity}
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default CarouselSettings
